import React from 'react';

const ResourcesPage = () => {
    return (
        <div>
            resources
        </div>
    );
};

export default ResourcesPage;